/**
 * Get initials from a user's name
 * @param name - The user's full name
 * @returns Two-letter initials or '?' if name is not provided
 */
export function getInitials(name?: string): string {
  if (!name) return '?'
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}
